<template>
  <div id="index_box">
    <!-- 头部 -->
    <v-header></v-header>
    <div id="main_box">
      <!-- 二级 路由出口 -->
      <!--      <keep-alive> -->
      <router-view></router-view>
      <!--      </keep-alive>-->
    </div>
    <!-- 底部 -->
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHeader from "../components/header.vue";
import vFooter from "../components/footer.vue";
import Cookies from "js-cookie";
export default {
  name: "App",
  components: {
    vHeader,
    vFooter,
  },
  mounted() {
    // Cookies.remove("$Station");
    // Cookies.set("$Station",'总站分站');
  },
  methods: {},
};
</script>


<style scoped>
#index_box {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#main_box {
  /* background-color: rgb(189, 219, 132); */
  /* mine 高度填充flex剩余高 */
  flex: 1;
  background-color: rgba(250, 249, 249, 1);
}
</style>
